import { createFileRoute } from '@tanstack/react-router';
import { Suspense } from 'react';
import { Loader2 } from 'lucide-react';

import { DataStoreEditor } from '@/components/settings/data-sources/data-store-editor';

export const Route = createFileRoute('/_app/settings/data-sources/$id/')({
  component: DataStoreDetailRoute,
});

function LoadingFallback() {
  return (
    <div className="flex h-64 items-center justify-center">
      <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
    </div>
  );
}

function DataStoreDetailRoute() {
  const { id } = Route.useParams();
  return (
    <Suspense fallback={<LoadingFallback />}>
      <DataStoreEditor dataStoreId={id} />
    </Suspense>
  );
}
